import React from 'react';
import styled from 'styled-components';
import TokenLocksPage from '../TokenLocksPage';

const PageContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 16px 0 100px 0;
  box-sizing: border-box;
  
  @media (max-width: 480px) {
    padding: 12px 0 100px 0;
  }
  
  /* Ensure child components are full width */
  & > * {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    
    @media (max-width: 480px) {
      padding-left: 12px;
      padding-right: 12px;
    }
  }
`;

const LocksPWA: React.FC = () => {
  return (
    <PageContainer>
      <TokenLocksPage />
    </PageContainer>
  );
};

export default LocksPWA;

